"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authTokenHeaderAxiosInterceptor = exports.legacySetBearerAuthToken = void 0;
const auth0Tokens_1 = require("./auth0Tokens");
/**
 * @deprecated use authentication.authTokenHeaderAxiosInterceptor
 */
const legacySetBearerAuthToken = (auth0Token, requestConfig) => {
    if (auth0Token) {
        // eslint-disable-next-line no-param-reassign
        requestConfig.headers = Object.assign(Object.assign({}, requestConfig.headers), { Authorization: `Bearer ${auth0Token}` });
    }
    return requestConfig;
};
exports.legacySetBearerAuthToken = legacySetBearerAuthToken;
/**
 * Sets the current Auth0 token as a bearer authorization token
 */
const authTokenHeaderAxiosInterceptor = (requestConfig) => {
    const auth0Token = (0, auth0Tokens_1.getCachedAuth0Token)();
    if (auth0Token) {
        // eslint-disable-next-line no-param-reassign
        requestConfig.headers = Object.assign(Object.assign({}, requestConfig.headers), { Authorization: `Bearer ${auth0Token}` });
    }
    return requestConfig;
};
exports.authTokenHeaderAxiosInterceptor = authTokenHeaderAxiosInterceptor;
//# sourceMappingURL=bearerAuth.js.map